<template>
  <div class="card">
    <div class="card-body">
      <!--<select class="form-control border-primary" @change="load($event.target.value)">-->
      <!--<option value="live" selected>Live Server</option>-->
      <!--<option value="dev">Dev Server</option>-->
      <!--</select>-->
      <h5>Ranking</h5>
      <dashboard-city v-for="city in cities" :city="city"/>
    </div>
  </div>
</template>

<script>

  import Backend from '@/Backend';
  import DashboardCity from "./DashboardCity";
  import EventBus from '@/EventBus';

  export default {
    name: "DashboardCityRanking",
    components: {DashboardCity},
    data() {
      return {
        cities: []
      }
    },
    methods: {
      load(server) {
        Backend.instance.getRanking(server)
          .then((data) => {
            this.cities = data;
            //this.cities.sort((a, b) => b.scores.score - a.scores.score);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    created() {
      EventBus.$on('scoresupdated', () => {
        this.load('dev');
      });
      this.load('dev');
    },
    destroyed() {
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardCityRanking.vue